export default (function (obj, key) {
  return obj.hasOwnProperty(key);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/has.js
// module id = 25
// module chunks = 0